var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMurumuru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_3504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5046 13.9022L9.6963 1.50849C9.63366 0.548024 8.38325 0.221876 7.85946 1.02938L1.1006 11.4493C-0.72195 14.2591 0.599584 18.0332 3.77681 19.0923C7.22614 20.2421 10.7412 17.5304 10.5046 13.9022ZM7.63874 6.89307C7.85583 6.5403 7.74584 6.07834 7.39307 5.86126C7.0403 5.64417 6.57834 5.75416 6.36126 6.10693L2.36126 12.6069C2.14417 12.9597 2.25416 13.4217 2.60693 13.6387C2.9597 13.8558 3.42166 13.7458 3.63874 13.3931L7.63874 6.89307Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4286 6.51096L11.7394 7.42861C10.7799 7.58338 10.1859 6.41668 10.8756 5.7318L14.9646 1.67115C16.3369 0.308384 18.6388 0.677464 19.5163 2.40094C20.3937 4.12441 19.3379 6.20299 17.4286 6.51096ZM16.5301 2.46958C16.823 2.76247 16.823 3.23734 16.5301 3.53024L15.0301 5.03024C14.7372 5.32313 14.2623 5.32313 13.9694 5.03024C13.6765 4.73734 13.6765 4.26247 13.9694 3.96958L15.4694 2.46958C15.7623 2.17668 16.2372 2.17668 16.5301 2.46958Z",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5773 10.1037L13.1972 16.435C14.2139 18.892 17.518 19.3091 19.1134 17.1819C20.3707 15.5055 19.8451 13.1036 18.0025 12.1055L11.9776 8.84202C11.1496 8.39353 10.2173 9.23358 10.5773 10.1037ZM13.5303 10.9697C13.2374 10.6768 12.7626 10.6768 12.4697 10.9697C12.1768 11.2626 12.1768 11.7374 12.4697 12.0303L14.4697 14.0303C14.7626 14.3232 15.2374 14.3232 15.5303 14.0303C15.8232 13.7374 15.8232 13.2626 15.5303 12.9697L13.5303 10.9697Z",
    fill: "#653024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_3504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMurumuru);
export default __webpack_public_path__ + "static/media/murumuru.4a3b7aa2c0fa0b3e1b13c17196ebc8d5.svg";
export { ForwardRef as ReactComponent };